import type { TabsSchemaType } from '@vedalib/editor/lib/brand'
import { PositionTabsElementType, ViewTabsElementType } from '@vedalib/editor/lib/brand'
import styled, { css } from 'styled-components'

import type { ElementStyleCss } from 'services/Branding/types'

export const Z_INDEX_TEXT_AND_SPLITER = 2
export const Z_INDEX_NAV_BUTTOS = 3
export const Z_INDEX_TABS_LIST = 1
export const Z_INDEX_TAB_ACTIVE = 1
export const Z_INDEX_TAB_MARKER = 1
export const DEFAULT_INDENT_TAB = 4
export const SPLITTER_WIDTH = '40px'

export const position = {
  [PositionTabsElementType.top]: 'column',
  [PositionTabsElementType.left]: 'row',
  [PositionTabsElementType.right]: 'row-reverse',
}

const TabElementStyled = styled.div<{ $styles: ElementStyleCss<TabsSchemaType>; $isV2?: boolean }>`
  display: flex;
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  flex-direction: ${({ $styles }) =>
    position[$styles.tabs.position as PositionTabsElementType] || 'column'};
  ${({ $styles }) => $styles.view.type === ViewTabsElementType.splitted && 'gap: 16px'};
  box-shadow: ${({ $styles }) =>
    $styles.view.type === ViewTabsElementType.solid ? $styles.effects.boxShadow : 'none'};
  border-radius: ${({ $styles }) => $styles.view.borderRadius};

  ${({ $isV2 }) =>
    $isV2 &&
    css`
      height: 100%;
    `};
`

export default TabElementStyled
